<template>
    <div class="login">
      <h1>Sign Up</h1>
      <input type="text" v-model="email" placeholder="email"><br>
      <input type="password" v-model="password" placeholder="Password"><br>
      <button @click="create">Sign Up</button>
      <p>Already have an account? <router-link to="/login">Login.</router-link></p>
    </div>
</template>

<script>
  import firebase from 'firebase';

  export default {
        name: "SignUp",
        data() {
          return{};
        },
        methods: {
          create: function () {
            firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
              function (user) {
                this.$router.replace('home')
              },
              function (err) {
                alert('Oops. ' + err.message)
              }
            )

          }
        }
    }
</script>

<style scoped>
  .login {
    margin-top: 40px;
  }
  input {
    margin: 10px 0;
    width: 20%;
    padding: 15px;
  }
  button {
    margin-top: 20px;
    width: 10%;
    cursor: pointer;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/SignUp.vue